export default process.env.NODE_ENV === 'production' ? 'https://sector5.verdedata.ro' : 'http://localhost:2755'
// export default process.env.NODE_ENV === 'production' ? 'https://lifturi-s6.dragos.club' : 'http://localhost:6555'
